export default __webpack_public_path__ + "static/media/droneForestInventory.e1fa6b70.pdf";